module.exports = __webpack_public_path__ + "assets/img/empty.928ee98f.svg";